import React, { useState, useRef, useEffect } from "react"
import PageTitle from "../components/PageTitle";
import Index from "../view/ForgotPassword/Index";
import { validateAll } from "indicative/validator";
import ToastAlert from "../common/ToastAlert";
import ApiCall from "../common/ApiCall";
import ResetPassword from "../view/ForgotPassword/ResetPassword";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getSlugByLang } from "../common/Helper";

export default function ForgotPaswordController({ view }) {

    const [state, setState] = useState({
        email: "",
        recaptchaToken: "",
        password: "",
        cpassword: "",
        error: [],
    })
    const { email, recaptchaToken, password, cpassword } = state;
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showCPassword, setShowCPassword] = useState(false);
    const [strength, setStrength] = useState(0);
    const navigate = useNavigate();
    const perems = useParams();
    const [isSamePass, setIsSamePass] = useState(false);
    const recaptchaRef = useRef(null);
    const user = useSelector((state) => state.user);
    const userlang = getSlugByLang(user?.language);
    const isDark = user.isDarkMode;


    const changeValue = (e) => {
        let value = e.target.value;
        setState({
            ...state,
            [e.target.name]: value
        })
        if (e.target.name === 'password') {
            checkStrength(value);
        }

        if (e.target.name === 'cpassword') {
            if (password && value === password) {
                setIsSamePass(true)
            } else {
                setIsSamePass(false)
            }

        }
    }

    const setRecaptchaToken = (token) => {
        // setState({
        //     ...state,
        //     recaptchaToken: token
        // })
        setState((prevState) => ({
            ...prevState,  // Keep all other previous state values intact
            recaptchaToken: token
        }));
    }

    const sendMail = (e) => {
        e?.preventDefault();

        if (isLoading) {
            return;
        }


        const rules = {
            email: 'required|email',
            // recaptchaToken: "required",
        }

        const message = {
            'email.required': 'Email is Required.',
            'email.email': 'please enter valid email.',
            'recaptchaToken.required': 'reCAPTCHA verification is required.',
        }

        validateAll(state, rules, message).then(async () => {

            setState({
                ...state,
                error: {}
            })
            setIsLoading(true)

            let data = {}
            data.email = email
            data.recaptchaToken = recaptchaToken

            // window.grecaptcha.reset();
            // recaptchaRef.current?.reset();
            const sendForgotPassMail = await ApiCall('post', 'submit-forgot-password', data)


            if (sendForgotPassMail) {
                // recaptchaRef.current?.reset();
                if (sendForgotPassMail?.data?.success) {
                    // window.grecaptcha.reset();
                    // recaptchaRef.current?.reset();

                    setIsLoading(false)
                    ToastAlert({ msg: sendForgotPassMail.data.message, msgType: 'success' });
                    navigate('/en/login')

                } else {

                    if (sendForgotPassMail?.data?.errors && Object.keys(sendForgotPassMail?.data?.errors).length) {

                        setState({
                            ...state,
                            error: sendForgotPassMail.data.errors,
                        })

                    } else {
                        // ToastAlert({ msg: sendForgotPassMail.data.message, msgType: 'error' });
                        const formaerrror = {};
                        formaerrror.email = sendForgotPassMail?.data?.message
                        setState({
                            ...state,
                            error: formaerrror,
                        })
                    }
                    setIsLoading(false)

                }
            } else {
                setIsLoading(false)
                ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
            }


        }).catch(errors => {
            setIsLoading(false)
            const formaerrror = {};
            if (errors.length) {
                errors.forEach(element => {
                    formaerrror[element.field] = element.message
                });
            } else {
                ToastAlert({ msg: errors?.message ?? 'Something went wrong', msgType: 'error' });
            }
            setState({
                ...state,
                error: formaerrror,
            })

        });

    }

    // RESTE PASSWORD
    const changePassword = (e) => {
        e?.preventDefault();

        if (isLoading) {
            return;
        }

        const rules = {
            password: 'required|min:8',
            cpassword: 'required|min:8|same:password',
        }

        const message = {
            'password.min': 'The password must contain a minimum of 8 characters.',
            'password.required': 'Password is Required.',
            'cpassword.required': 'Please enter password again.',
            'cpassword.same': 'Password and confirm password must be same.',
        }


        validateAll(state, rules, message).then(async () => {




            setState({
                ...state,
                error: {}
            })
            setIsLoading(true)

            let data = {}

            data.new_password = password
            data.confirm_password = cpassword
            data.token = perems.token

            const resetPass = await ApiCall('post', 'submit-reset-password', data)

            if (resetPass) {
                if (resetPass?.data?.success) {


                    setIsLoading(false)
                    ToastAlert({ msg: resetPass.data.message, msgType: 'success' });
                    navigate('/en/login')

                } else {

                    if (resetPass.data.errors && Object.keys(resetPass.data.errors).length) {

                        setState({
                            ...state,
                            error: resetPass.data.errors,
                        })

                    } else {
                        // ToastAlert({ msg: resetPass.data.message, msgType: 'error' });
                        const formaerrror = {};
                        formaerrror.password = resetPass.data.message
                        setState({
                            ...state,
                            error: formaerrror,
                        })
                    }
                    setIsLoading(false)

                }
            } else {
                setIsLoading(false)
                ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
            }

        }).catch(errors => {
            setIsLoading(false)
            const formaerrror = {};
            if (errors.length) {
                errors.forEach(element => {
                    formaerrror[element.field] = element.message
                });
            } else {
                ToastAlert({ msg: errors?.message ?? 'Something went wrong', msgType: 'error' });
            }


            setState({
                ...state,
                error: formaerrror,
            })

        });

    }

    const checkStrength = (password) => {
        let score = 0;

        if (password.length >= 8) score++; // Length
        if (/[A-Z]/.test(password)) score++; // Uppercase letter
        if (/[a-z]/.test(password)) score++; // Lowercase letter
        if (/[0-9]/.test(password)) score++; // Number
        if (/[^A-Za-z0-9]/.test(password)) score++; // Special character


        setStrength(score);
    };

    const getClassNames = (index) => {
        if (password.length === 0) {
            return 'comSpan';
        }

        const classNames = ['comSpan'];

        if (strength >= 1) {
            classNames[0] = 'comSpan redSpan';
        }
        if (strength >= 2) {
            classNames[1] = 'comSpan yellowSpan';
        }
        if (strength >= 3) {
            classNames[2] = 'comSpan greenSpan';
        }
        return classNames[index] || 'comSpan';
    };

    const handhandleShowPassword = (e, type) => {
        e?.preventDefault();
        if (type === 1) {
            setShowPassword(!showPassword)
        } else {
            setShowCPassword(!showCPassword)

        }
    }

    const resetRecaptcha = (e) => {
        // console.log(e);

        if (window.grecaptcha) {
            window.grecaptcha.reset();
        }
        recaptchaRef.current?.reset();
        setRecaptchaToken(null);
        // setError(null);
    };

    // useEffect(() => {
    //     // Initialize reCAPTCHA after the component mounts
    //     if (window.grecaptcha && recaptchaRef.current) {

    //         window.grecaptcha.render(recaptchaRef.current, {
    //             sitekey: process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY, // Replace with your reCAPTCHA site key
    //             callback: setRecaptchaToken,  // The function that gets called when the user completes the reCAPTCHA
    //         });
    //     }
    // }, []);



    return (
        <>

            <PageTitle title={view === 'forgot' ? 'Forgot Password' : 'Reset Password'} />
            {
                view === 'forgot' ?

                    <Index
                        state={state}
                        sendMail={sendMail}
                        changeValue={changeValue}
                        isLoading={isLoading}
                        setRecaptchaToken={setRecaptchaToken}
                        resetRecaptcha={resetRecaptcha}
                        recaptchaRef={recaptchaRef}
                        userlang={userlang}
                    /> :
                    <ResetPassword
                        state={state}
                        changeValue={changeValue}
                        changePassword={changePassword}
                        showPassword={showPassword}
                        showCPassword={showCPassword}
                        handhandleShowPassword={handhandleShowPassword}
                        getClassNames={getClassNames}
                        setRecaptchaToken={setRecaptchaToken}
                        isLoading={isLoading}
                        isSamePass={isSamePass}
                        isDark={isDark}
                        userlang={userlang}




                    />
            }
        </>
    )

}